export default class MathGenerator {
    // Public:
    constructor(cParams) {
        this._type = cParams.type;
        this._weight = cParams.weight;
    }

    compute() {
        let type = this._type;
        let k = this._weight;
        let f = () => 1.0;
        switch (type) {
            case "EQUAL":
                f = () => 1.0;
                break;
            case "LINEAR":
                f = d => d;
                break;
            case "SQRT":
                f = d => Math.sqrt(d);
                break;
            default:
                break;
        }
        let func = d => k * f(d);
        return func;
    }

    // Private:
}
